import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ensureSessionCredentials, getLoginPathForRole } from '../services/ensureSessionCredentials';
import { useMarketingAuth } from './useMarketingAuth';

export function useOpenDashboard() {
    const navigate = useNavigate();
    const { isSignedIn, role, dashboardPath } = useMarketingAuth();
    const [openingDashboard, setOpeningDashboard] = useState(false);

    const openDashboard = useCallback(async (event) => {
        event?.preventDefault();

        if (!role || !dashboardPath || openingDashboard) {
            return;
        }

        setOpeningDashboard(true);

        try {
            const result = await ensureSessionCredentials(role);

            if (!result.ok) {
                navigate(getLoginPathForRole(role), { replace: true, state: { sessionExpired: true } });
                return;
            }

            if (result.role === 'user') {
                sessionStorage.setItem('userDashboardState', JSON.stringify(result.navigationState));
            }

            navigate(result.dashboardPath, {
                state: result.navigationState,
            });
        } finally {
            setOpeningDashboard(false);
        }
    }, [dashboardPath, navigate, openingDashboard, role]);

    return {
        isSignedIn,
        dashboardPath,
        openDashboard,
        openingDashboard,
    };
}
